import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          常见问题
        </h2>
        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <div className="p-5">
                <h3 className="text-sm font-medium text-foreground-800 flex items-start gap-3">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-line"></i>
                  </span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3 pl-7">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}